import React, { useState } from 'react'
import { Col, Container, Row, Button, Modal } from 'react-bootstrap';
import { IoIosArrowDroprightCircle } from "react-icons/io";
import Photo1 from '../Medias/Services/service_1.png';
import Photo2 from '../Medias/Services/service_2.png';
import Photo3 from '../Medias/Services/service_3.png';
import Photo4 from '../Medias/Services/service_4.png';
import Photo5 from '../Medias/Services/service_5.png';
import Photo6 from '../Medias/Services/service_6.png';
import Photo7 from '../Medias/Services/service_7.png';

const SectionHomeService = ({ hideHeader = false }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ name: '', detail: '', content: null });

  const handleShow = (item) => {
    setModalContent(item);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const mockup = [
    {
      icon: Photo1,
      topic: 'Corporate and Mergers and Acquisitions (M&A)',
      subtopic: 'Our extensive experience advising from both perspectives of government regulators and private stakeholders provided us with the differentiating expertise when it comes to corporate and M&A concerning the energy industry of Thailand.',
      detail: <>
        <Row>
          <Col xs={12} md={6} className='px-4 mt-5 mt-md-0'>
            <div className='text-center'>
              <img src={Photo1} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Corporate and M&A</h4>
            </div>
            <p>Our extensive experience advising from both perspectives of government regulators and private stakeholders provided us with the differentiating expertise when it comes to corporate and M&A concerning the energy industry of Thailand. Our team members are well-versed in both the theoretical and practical aspects of these Thai energy regulatory frameworks at various levels of sophistication, which offers tremendous value in the formulation of our clients’ corporate and M&A strategies.</p>
            <p>In particular, we developed our in-house knowledge of shifting regulatory environments to guide our clients in navigating compliance barriers, mitigating transactional risks, and optimizing market opportunities from these M&A endeavours. Our services take a holistic approach to covering all the significant aspects of M&A, which frequently result in critical pain points for clients who struggle with the legal intricacies of Thailand’s energy supply chain. Each client can have confidence in our professional and bespoke legal services which are oriented towards maximizing the synergy between regulatory compliance and achieving favorable M&A outcomes.</p>
          </Col>
          <Col xs={12} md={6} className='px-4 mt-5 mt-md-0'>
            <div className='text-center'>
              <img src={Photo1} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Corporate and M&A Services</h4>
            </div>
            <p>In relation to corporate and M&A, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>M&A Regulatory Applications and Market Analyses</li>
              <li>Legal and Regulatory Compliance</li>
              <li>Corporate and Organizational Governance</li>
              <li>Corporate Reorganization and Restructuring</li>
              <li>Private Equity Investment</li>
              <li>Special Purpose Vehicles (SPVs) and Holding Companies Structuring</li>
              <li>General Corporate and Governance Issues</li>
              <li>Joint Venture Structuring Management</li>
              <li>Post-Merger Integration (PMI) Support</li>
              <li>General Corporate and Governance Matters</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo2,
      topic: 'Public-Private Partnership (PPP)',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo2} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Public-Private Partnership (PPP)</h4>
            </div>
            <p>Having extensively worked on notable transactions dealing with the Public-Private Partnership Act B.E. 2562 (2019) which provides the fundamental PPP legal framework in Thailand, our team could help clients avoid regulatory pitfalls and comply with intricate legislative and regulatory requirements. With our methodological guidance, our clients could acquire a competitive edge in benefiting from PPP arrangements designed for superior infrastructure, expedited project completion, improved risk oversight, and higher return on investment (ROI).</p>
            <p>In relation to PPP, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>Legal and Regulatory Compliance</li>
              <li>Legal Due Diligence Investigation</li>
              <li>Agreements and Concessions</li>
              <li>Private Finance Initiative (PFI)</li>
              <li>Advice and Negotiation on PPP Contracts</li>
              <li>Market Sounding for PPP Projects</li>
              <li>General Privitization Matters</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo3,
      topic: 'Data and Technology',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo3} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Data and Technology</h4>
            </div>
            <p>Having worked considerably on prominent transactions dealing with the Personal Data Protection Act B.E. 2562 (2019) of Thailand in relation to the European Union’s (EU) General Data Protection Regulation (GDPR), our team could help clients with a comprehensive range of procedural and regulatory matters for data and privacy protection. Our services encompass the preparation and negotiation of software and technology agreements on matters such as software development, licensing, collaboration, reselling and distribution, as well as advising on software and vendor disputes. Furthermore, we provide support in addressing legal issues arising from digital transformation initiatives such as blockchain, cybersecurity, cloud computing, financial technology (fintech), internet of things (IoT), and artificial intelligence (AI).</p>
            <p>In relation to data and technology, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>Data Privacy and Protection Compliance</li>
              <li>Data Retention and Transfer Protocols</li>
              <li>Cybersecurity Risk Management</li>
              <li>Technology Transfer Transactions</li>
              <li>Legal Frameworks for Digital Transformation Initiatives</li>
              <li>General Data Protection Compliance Matters</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo4,
      topic: 'Energy Infrastructure Projects',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo4} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Energy Infrastructure Projects</h4>
            </div>
            <p>Our comprehensive knowledge of the regulatory landscape of Thailand enables us to provide detailed advice to clients on planning, negotiating and implementing projects across various energy infrastructure subjects and types, particularly relating to the renewable energy (RE) industry. Our services for energy infrastructure projects extend to preparing feasibility study reports and providing project finance advice in coordination with technical and financial experts. Our team guides clients across multiple phases of the energy infrastructure life cycle particularly when synergized with public-private partnership (PPP) schemes.</p>
            <p>In relation to energy infrastructure projects, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>Legal and Regulatory Research</li>
              <li>License Checklist Preparation for Energy Project Development</li>
              <li>Feasibility Study Report Preparation</li>
              <li>Advice and Negotiation on Power Purchase Agreements (PPP)</li>
              <li>Advice and Negotiation on Wheeling Service Agreements</li>
              <li>Legal Advice on Project Finance Structuring</li>
              <li>Assistance with Land Acquisition and Real Estate Matters</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo5,
      topic: 'ICT and Digital Assets',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo5} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>ICT and Digital Assets</h4>
            </div>
            <p>Our legal team is among the pioneering specialists in Thailand when it comes to the emerging information and communication technology (ICT) and digital assets practice at par with international regulatory benchmarks. Our ICT and digital assets practice explores legal solutions enabling our clients to capitalize on novel and emerging fintech-as-a-service within the framework of relevant laws and regulations such as those relating to anti-money laundering (AML), know your customer (KYC), e-payment, and digital asset business operations. Our legal advisory services assist clients with accessing alternative fundraising methods including real-world asset (RWA) tokenization and initial coin offering (ICO).</p>
            <p>In relation to ICT and digital assets, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>Multi-jurisdictional Digital Assets Regulatory Compliance</li>
              <li>Advisory for Digital Asset Trading, Platforms, Brokers and Exchanges</li>
              <li>RWA Tokenization</li>
              <li>Digital Asset Investment Funds</li>
              <li>Digital Asset Infrastructure Management</li>
              <li>ICO Compliance, Reporting and Rollout</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo6,
      topic: 'Intellectual Property',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo6} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Intellectual Property</h4>
            </div>
            <p>Our extensive range of intellectual property (IP) legal services is designed to benefit clients by safeguarding their patents copyrights, trademarks, industrial designs, trade secrets and other IP against infringement and unfair competition in order to optimize the value of their IP assets and shield their competitive advantages. Our IP legal services include guiding and advising clients throughout the patent registration process from preparing patent applications, crafting specifications and claims, and navigating patent filing with pertinent government agencies and organizations.</p>
            <p>In relation to IP, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>IP Due Diligence</li>
              <li>IP Registration and Prosecution</li>
              <li>IP Portfolio Management</li>
              <li>IP Licensing and Technology Transfer</li>
              <li>Trade Secret Protection</li>
              <li>IP Litigation</li>
            </ul>
          </Col>
        </Row>
      </>
    },
    {
      icon: Photo7,
      topic: 'Dispute Resolution and Arbitration',
      subtopic: '',
      detail: <>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-4'>
            <div className='text-center'>
              <img src={Photo7} className='w-100 mt-3' style={{ maxWidth: '120px' }} />
              <h4 className='font-header'>Dispute Resolution and Arbitration</h4>
            </div>
            <p>Our legal team supports clients in resolving business disputes through either litigation before Thai courts or through alternative dispute resolution (ADR) including mediation and arbitration. Our end-to-end services incorporate business-oriented considerations for dispute resolution that advocate ADR approaches for our clients. Using thorough knowledge of our clients’ enterprises, we utilize tailored dispute resolution strategies that protect their business interests regardless of dispute novelty and complexity.</p>
            <p>In relation to dispute resolution and arbitration, our team is prepared to advise and assist clients on the following matters:</p>
            <ul>
              <li>Advice on Mediation and Arbitration Proceedings</li>
              <li>Advice on Court and ADR Dispute Resolution Processes</li>
              <li>Arbitral Award Enforcement</li>
              <li>Litigation Representation</li>
            </ul>
          </Col>
        </Row>
      </>
    },
  ];

  return (
    <>
      <section className='pb-5'>
        <Container>
          {hideHeader ? null :
            <h1 className='font-header text-center mb-5'>Our Services</h1>
          }
          <Row>
            {mockup.map((item, index) => (
              index === 0 ?
                <Col xs={12} md={4} className='text-center px-4'>
                  <h4>Specialization and Expertise</h4>
                  <img src={Photo1} className='w-100' style={{ maxWidth: '240px' }} />
                  <h6 className='font-header'>{item.topic}</h6>
                  <p>{item.subtopic}</p>
                  <Button
                    className={`p-0 bg-transparent border-0 text-decoration-none fw-bold text-black`}
                    onClick={() => handleShow(item)}
                  >
                    Read More <IoIosArrowDroprightCircle size={20} className='ms-1 mb-1' />
                  </Button>
                </Col>
                : null
            ))}
            <Col xs={12} md={8} className='px-4 mt-5 mt-md-0'>
              <h4 className='text-center'>Ancillary Proficiencies</h4>
              <Row className='mb-4'>
                <Col xs={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }}>
                  <p>To augment our premier corporate and M&A practice, we cater to the following strategic legal areas  as required by the business requirements and circumstances of our clients. We provide ancillary proficiencies in these areas as part of our comprehensive legal services for our clients within the ambit of our core energy law practice:</p>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }}>
                  <Row>
                    {mockup.map((item, index) => (
                      index > 0 ?
                        <Col xs={12} md={6} className='mb-4'>
                          <div className='d-flex flex-row'>
                            <div className='text-center'>
                              <img src={item.icon} className='w-100 mt-2' style={{ maxHeight: '60px', maxWidth: '60px', minHeight: '60px', minWidth: '60px' }} />
                            </div>
                            <div className='px-3'>
                              <h6 className='font-header mt-2'>{item.topic}</h6>
                              <Button
                                className={`p-0 bg-transparent border-0 text-decoration-none fw-bold text-black`}
                                onClick={() => handleShow(item)}
                              >
                                Read More <IoIosArrowDroprightCircle size={20} className='ms-1 mb-1' />
                              </Button>
                            </div>
                          </div>
                        </Col>
                        : null
                    ))}
                  </Row>
                </Col>
              </Row>

            </Col>
          </Row>
        </Container>
      </section>

      {/* Modal */}
      <Modal show={showModal} size='xl' onHide={handleClose} className="modal-fullscreen">
        <Modal.Header className='px-4' closeButton>
          <Modal.Title>Our Services</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-4'>
          <p>{modalContent.detail}</p>
          {modalContent.content}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SectionHomeService